module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"once":"Единоразово","interviews":"Отклики","sms":"SMS","calls":"Звонки"}}')
  delete Component.options._Ctor
}
